// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1AtPc","options":"AnswerScale_options__YZ2Fp","selected":"AnswerScale_selected__2cHFg"};